// Dictionary of UI strings for the Intelligence DB platform.
// Keys are kebab-dot-style. Missing keys fall back to the Italian value or the key itself.

export const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

const dict = {
  // ── Global / common
  "common.save": { it: "Salva", en: "Save" },
  "common.save_all": { it: "Salva tutto", en: "Save all" },
  "common.saving": { it: "Salvataggio...", en: "Saving..." },
  "common.saved": { it: "Salvato!", en: "Saved!" },
  "common.cancel": { it: "Annulla", en: "Cancel" },
  "common.edit": { it: "Modifica", en: "Edit" },
  "common.delete": { it: "Elimina", en: "Delete" },
  "common.add": { it: "Aggiungi", en: "Add" },
  "common.close": { it: "Chiudi", en: "Close" },
  "common.reset": { it: "Reset", en: "Reset" },
  "common.loading": { it: "Caricamento...", en: "Loading..." },
  "common.search": { it: "Ricerca", en: "Search" },
  "common.all": { it: "Tutte", en: "All" },
  "common.all_m": { it: "Tutti", en: "All" },
  "common.yes": { it: "Sì", en: "Yes" },
  "common.no": { it: "No", en: "No" },
  "common.target": { it: "Target", en: "Target" },
  "common.company": { it: "Azienda", en: "Company" },
  "common.logout": { it: "Esci", en: "Logout" },
  "common.theme_light": { it: "Passa al tema chiaro", en: "Switch to light theme" },
  "common.theme_dark": { it: "Passa al tema scuro", en: "Switch to dark theme" },
  "common.language": { it: "Lingua", en: "Language" },
  "common.date": { it: "Data", en: "Date" },
  "common.status": { it: "Stato", en: "Status" },
  "common.license_holder": { it: "Licenza", en: "License" },

  // ── Sidebar menu
  "menu.house_of_intelligence": { it: "AI Agent James", en: "AI Agent James" },
  "menu.crm": { it: "Integrated CRM", en: "Integrated CRM" },
  "hoi.link_online": { it: "Canale Attivo", en: "Channel Online" },
  "hoi.subtitle": { it: "Cockpit Operativo AI", en: "AI Operative Cockpit" },
  "hoi.briefing": { it: "Briefing Missione", en: "Mission Briefing" },
  "hoi.brief_1": { it: "Ricerca su 500+ profili e 200+ aziende monitorate.", en: "Search across 500+ profiles and 200+ tracked companies." },
  "hoi.brief_2": { it: "Analizza brevetti, tecnologie, dati finanziari.", en: "Analyze patents, technologies, financials." },
  "hoi.brief_3": { it: "Estrai insight da fonti OSINT, SOCMINT e HUMINT.", en: "Extract insights from OSINT, SOCMINT and HUMINT sources." },
  "hoi.brief_4": { it: "Genera report comparativi e benchmark settoriali.", en: "Generate comparative reports and sector benchmarks." },
  "hoi.session": { it: "Sessione Corrente", en: "Current Session" },
  "hoi.mission": { it: "Missione", en: "Mission" },
  "hoi.exchanges": { it: "msg", en: "msg" },
  "hoi.session_active": { it: "Sessione in corso. Tutti i messaggi sono crittografati.", en: "Session in progress. All messages are encrypted." },
  "hoi.session_idle": { it: "Pronto a ricevere la prima domanda operativa.", en: "Ready to receive your first operative query." },
  "hoi.purge_session": { it: "Termina Sessione", en: "Purge Session" },
  "hoi.uplink": { it: "Uplink AI", en: "AI Uplink" },
  "hoi.classified": { it: "Solo uso interno autorizzato.", en: "Authorized internal use only." },
  "hoi.encrypted": { it: "Canale Crittografato", en: "Encrypted Channel" },
  "hoi.header_caption": { it: "AI Agent James — connesso al database operativo MOONSTONE", en: "AI Agent James — connected to the MOONSTONE operational database" },
  "hoi.welcome_title": { it: "Benvenuto, Operatore.", en: "Welcome, Operator." },
  "hoi.welcome_subtitle": { it: "AI Agent James è pronto a estrarre, correlare e analizzare dati dalla piattaforma. Formula una richiesta operativa o seleziona un'azione rapida.", en: "AI Agent James is ready to extract, correlate and analyze data from the platform. Type an operative query or pick a suggested action." },
  "hoi.suggestions_title": { it: "Azioni Rapide Suggerite", en: "Suggested Quick Actions" },
  "hoi.suggest.companies": { it: "Mappatura Aziende", en: "Companies Mapping" },
  "hoi.suggest.competitors": { it: "Analisi Competitor", en: "Competitor Analysis" },
  "hoi.suggest.patents": { it: "Brevetti & Tecnologie", en: "Patents & Technologies" },
  "hoi.suggest.warroom": { it: "Mercati & Clienti", en: "Markets & Clients" },
  "hoi.placeholder": { it: "Inserisci richiesta operativa…", en: "Enter operative query…" },
  "hoi.input_hint": { it: "Premi INVIO per inviare · AI Agent James risponde in italiano", en: "Press ENTER to send · AI Agent James replies in English" },
  "hoi.disclaimer": { it: "TLP:AMBER · Solo Uso Interno", en: "TLP:AMBER · Internal Use Only" },
  "menu.dashboard": { it: "Dashboard", en: "Dashboard" },
  "menu.identity_card": { it: "Intelligence", en: "Intelligence" },
  "menu.people": { it: "Search People", en: "Search People" },
  "menu.company": { it: "Search Company", en: "Search Company" },
  "menu.people_list": { it: "People List", en: "People List" },
  "menu.list": { it: "Business List", en: "Business List" },
  "menu.account_check": { it: "Account Check", en: "Account Check" },
  "menu.sales_intelligence": { it: "Sales Monitor", en: "Sales Monitor" },
  "menu.supplier_monitor": { it: "Supplier Monitor", en: "Supplier Monitor" },
  "menu.supplier_intelligence": { it: "Supplier Monitor", en: "Supplier Monitor" },
  "menu.event_intelligence": { it: "Event and Fairs", en: "Event and Fairs" },
  "menu.tradeshow": { it: "B2B Fairs", en: "B2B Fairs" },
  "menu.network": { it: "B2B Events", en: "B2B Events" },
  "menu.war_room": { it: "War Room", en: "War Room" },
  "menu.hr_research": { it: "Talent Acquisition", en: "Talent Acquisition" },
  "menu.candidates": { it: "Candidati", en: "Candidates" },
  "menu.tech": { it: "Business Asset", en: "Business Asset" },
  "menu.customer_support": { it: "Customer Support", en: "Customer Support" },
  "menu.contract_twin": { it: "Contract Twin", en: "Contract Twin" },
  "menu.patents": { it: "Patents", en: "Patents" },
  "menu.technologies": { it: "Technologies", en: "Technologies" },
  "menu.contextual": { it: "Regulatory Affairs", en: "Regulatory Affairs" },
  "menu.customs": { it: "Dogane", en: "Customs" },
  "menu.finance": { it: "Finanziaria", en: "Financial" },
  "menu.commerce": { it: "Commerciale", en: "Commercial" },
  "menu.tenders": { it: "Gare & Appalti", en: "Tenders & Bids" },
  "menu.academy": { it: "Accademy", en: "Academy" },
  "menu.reportistica": { it: "Business Analytics", en: "Business Analytics" },
  "menu.courses": { it: "Training Courses", en: "Training Courses" },
  "menu.course_docs": { it: "Course Documents", en: "Course Documents" },
  "menu.library": { it: "Library", en: "Library" },
  "menu.university": { it: "Moonstone University", en: "Moonstone University" },
  "menu.knowledge": { it: "Knowledge Base", en: "Knowledge Base" },
  "menu.people_monitor": { it: "People Watch", en: "People Watch" },
  "menu.company_monitor": { it: "Business Watch", en: "Business Watch" },
  "menu.tradeshow_monitor": { it: "B2B Fairs", en: "B2B Fairs" },
  "menu.network_monitor": { it: "B2B Events", en: "B2B Events" },
  "menu.candidate_monitor": { it: "People Verification", en: "People Verification" },
  "menu.customs_context": { it: "Customs Context", en: "Customs Context" },
  "menu.finance_context": { it: "Financial Context", en: "Financial Context" },
  "menu.sales_context": { it: "Sales Context", en: "Sales Context" },
  "menu.tenders_context": { it: "Tenders Context", en: "Tenders Context" },
  "menu.training_course": { it: "Training Course", en: "Training Course" },
  "menu.course_document": { it: "Course Document", en: "Course Document" },
  "menu.knowledge_center": { it: "Knowledge Center", en: "Knowledge Center" },
  "menu.report_document": { it: "Report & Document", en: "Report & Document" },
  "menu.repository": { it: "Repository", en: "Repository" },

  // ── Intelligence pages / panels
  "intel.personas_title_sales": { it: "Sales Intelligence — Personas", en: "Sales Intelligence — Personas" },
  "intel.company_title_sales": { it: "Sales Intelligence — Company", en: "Sales Intelligence — Company" },
  "intel.personas_title_supplier": { it: "Supplier Intelligence — People", en: "Supplier Intelligence — People" },
  "intel.company_title_supplier": { it: "Supplier Intelligence — Company", en: "Supplier Intelligence — Company" },
  "intel.subtitle": { it: "OSINT · SOCMINT · HUMINT", en: "OSINT · SOCMINT · HUMINT" },
  "intel.entries": { it: "entries", en: "entries" },
  "intel.entry": { it: "entry", en: "entry" },
  "intel.total_entries": { it: "entries totali", en: "total entries" },
  "intel.loading": { it: "Caricamento dati intelligence...", en: "Loading intelligence data..." },
  "intel.osint_desc_person": { it: "Informazioni raccolte da fonti pubbliche: news, comunicati, database, pubblicazioni, siti web", en: "Information gathered from public sources: news, press releases, databases, publications, websites" },
  "intel.osint_desc_company": { it: "News, comunicati stampa, bilanci pubblici, registri camerali, database, pubblicazioni", en: "News, press releases, public financial statements, business registries, databases" },
  "intel.socmint_desc_person": { it: "Profili social attivi, visibilità pubblica, attività, follower e contenuti pubblicati", en: "Active social profiles, public visibility, activity, followers and published content" },
  "intel.socmint_desc_company": { it: "Presenza e attività sui social: LinkedIn aziendale, X/Twitter, Instagram, YouTube", en: "Presence and activity on social: corporate LinkedIn, X/Twitter, Instagram, YouTube" },
  "intel.humint_desc_person": { it: "Interazioni dirette: fiere, telefonate, email, meeting, referral e canali umani", en: "Direct interactions: trade shows, phone calls, emails, meetings, referrals and human channels" },
  "intel.humint_desc_company": { it: "Interazioni con rappresentanti aziendali in fiera, telefono, email e altri canali diretti", en: "Interactions with company reps at trade shows, phone, email and other direct channels" },

  // ── Toolbar (filters + sort)
  "toolbar.filters": { it: "Filtri", en: "Filters" },
  "toolbar.search_text": { it: "Ricerca testo", en: "Text search" },
  "toolbar.search_placeholder": { it: "titolo, fonte, username, note...", en: "title, source, username, notes..." },
  "toolbar.importance_ge": { it: "Importanza ≥", en: "Importance ≥" },
  "toolbar.sort_by": { it: "Ordina per", en: "Sort by" },
  "toolbar.sort_default": { it: "Default", en: "Default" },
  "toolbar.sort_imp_desc": { it: "Importance ↓ (Critici prima)", en: "Importance ↓ (Critical first)" },
  "toolbar.sort_imp_asc": { it: "Importance ↑ (Info prima)", en: "Importance ↑ (Info first)" },
  "toolbar.sort_date_desc": { it: "Data più recente", en: "Most recent" },
  "toolbar.sort_date_asc": { it: "Data più vecchia", en: "Oldest first" },
  "toolbar.platform": { it: "Piattaforma", en: "Platform" },
  "toolbar.category": { it: "Categoria", en: "Category" },
  "toolbar.channel": { it: "Canale", en: "Channel" },
  "toolbar.hidden_by_filter": { it: "nascoste dal filtro", en: "hidden by filter" },
  "toolbar.of": { it: "di", en: "of" },

  // ── Importance labels
  "importance.1": { it: "INFO", en: "INFO" },
  "importance.2": { it: "BASSO", en: "LOW" },
  "importance.3": { it: "MEDIO", en: "MEDIUM" },
  "importance.4": { it: "ALTO", en: "HIGH" },
  "importance.5": { it: "CRITICO", en: "CRITICAL" },

  // ── Verification badges (Identity Card)
  "verif.verified": { it: "VERIFIED", en: "VERIFIED" },
  "verif.fraud": { it: "FRAUD", en: "FRAUD" },
  "verif.report.eyebrow": { it: "REPORT DI VERIFICA", en: "VERIFICATION REPORT" },
  "verif.report.tooltip": { it: "Clicca per aprire il report di verifica", en: "Click to open verification report" },
  "verif.report.loading": { it: "Elaborazione report di verifica...", en: "Generating verification report..." },
  "verif.report.error": { it: "Impossibile caricare il report.", en: "Unable to load the report." },
  "verif.report.score": { it: "Score di affidabilità", en: "Trust score" },
  "verif.report.signals": { it: "SEGNALI ANALIZZATI", en: "ANALYZED SIGNALS" },
  "verif.report.recommendation": { it: "RACCOMANDAZIONE", en: "RECOMMENDATION" },
  "verif.report.generated": { it: "Generato", en: "Generated" },
  "verif.report.outcome.pass": { it: "PASS", en: "PASS" },
  "verif.report.outcome.warn": { it: "WARN", en: "WARN" },
  "verif.report.outcome.fail": { it: "FAIL", en: "FAIL" },

  // ── Chat Assistant
  "chat.title": { it: "MOONSTONE Assistant", en: "MOONSTONE Assistant" },
  "chat.subtitle": { it: "Claude Sonnet 4.5 · competitive intel", en: "Claude Sonnet 4.5 · competitive intel" },
  "chat.hello": { it: "Ciao!", en: "Hello!" },
  "chat.intro_prefix": { it: "Sono", en: "I'm" },
  "chat.intro_suffix": { it: ". Interrogo i dati della piattaforma (prospect, intelligence, fiere, war room, HR, gare...) e rispondo alle tue domande. Prova una di queste:", en: ". I query the platform data (prospects, intelligence, trade shows, war room, HR, tenders...) and answer your questions. Try one of these:" },
  "chat.new_conversation": { it: "Nuova conversazione", en: "New conversation" },
  "chat.placeholder": { it: "Fai una domanda sulla piattaforma...", en: "Ask a question about the platform..." },
  "chat.thinking": { it: "MOONSTONE sta ragionando...", en: "MOONSTONE is reasoning..." },
  "chat.disclaimer": { it: "Risposte basate solo sui dati della tua piattaforma", en: "Answers based only on your platform data" },
  "chat.loading_history": { it: "Caricamento cronologia...", en: "Loading history..." },
  "chat.you": { it: "TU", en: "YOU" },
  "chat.alterego": { it: "MOONSTONE", en: "MOONSTONE" },
  "chat.error": { it: "Errore: impossibile contattare l'AI.", en: "Error: unable to reach the AI." },
  "chat.aria_open": { it: "Apri MOONSTONE Assistant", en: "Open MOONSTONE Assistant" },
  "chat.suggestion.1": { it: "Quali sono i 3 prospect più rilevanti in portafoglio?", en: "Who are the 3 most relevant prospects in the pipeline?" },
  "chat.suggestion.2": { it: "Riassumi le informazioni OSINT con importance critica.", en: "Summarize the OSINT entries with critical importance." },
  "chat.suggestion.3": { it: "Quali fiere abbiamo in agenda nei prossimi 6 mesi?", en: "Which trade shows are upcoming in the next 6 months?" },
  "chat.suggestion.4": { it: "Quali candidati HR hanno check CV 'sconsigliato'?", en: "Which HR candidates have a 'not recommended' CV check?" },
  "chat.suggestion.5": { it: "Panoramica delle gare d'appalto aperte.", en: "Overview of open tenders." },

  // ── Daily Insight widget
  "insight.title": { it: "Insight del giorno", en: "Daily Insight" },
  "insight.subtitle": { it: "Segnali critici estratti da MOONSTONE AI dalle tue intelligence", en: "Critical signals extracted by MOONSTONE AI from your intelligence" },
  "insight.generating": { it: "MOONSTONE sta generando gli insight...", en: "MOONSTONE is generating insights..." },
  "insight.regenerate": { it: "Rigenera", en: "Regenerate" },
  "insight.empty": { it: "Nessun segnale critico rilevato oggi.", en: "No critical signals detected today." },
  "insight.updated": { it: "Aggiornato", en: "Updated" },
  "dash.updated": { it: "Ultimo aggiornamento", en: "Last updated" },
  "insight.powered": { it: "Powered by Claude Sonnet 4.5", en: "Powered by Claude Sonnet 4.5" },

  // ── Language selector
  "lang.select": { it: "Cambia lingua", en: "Change language" },

  // ── Landing page
  "landing.nav.features": { it: "Funzionalità", en: "Features" },
  "landing.nav.modules": { it: "Moduli", en: "Modules" },
  "landing.nav.security": { it: "Sicurezza", en: "Security" },
  "landing.nav.contact": { it: "Contatti", en: "Contact" },
  "landing.nav.login": { it: "Login", en: "Login" },
  "landing.nav.cta": { it: "Accedi", en: "Sign in" },
  "landing.hero.tag": { it: "Piattaforma di Competitive & Sales Intelligence", en: "Competitive & Sales Intelligence Platform" },
  "landing.hero.title_a": { it: "Dal caos dei dati alla", en: "From Data noise to" },
  "landing.hero.title_b": { it: "sicurezza nelle decisioni", en: "Decision Confidence" },
  "landing.hero.sub": { it: "Moonstone fonde open source, social e human intelligence in un unico comando. Mappa globale, schede competitor, intelligence strutturata e pipeline commerciale. Tutto in un click.", en: "Moonstone merges open source, social and human intelligence into one cockpit. Global map, competitor profiles, structured intelligence, commercial pipeline. Just one click." },
  "landing.hero.cta_primary": { it: "Accedi", en: "Sign in" },
  "landing.hero.cta_secondary": { it: "Esplora i moduli", en: "Explore the modules" },
  "landing.trust.tag": { it: "Unica piattaforma per la tua intelligence", en: "One platform for all your intelligence" },
  "landing.trust.1": { it: "Intelligence", en: "Intelligence" },
  "landing.trust.2": { it: "Cockpit", en: "Cockpit" },
  "landing.trust.3": { it: "Mappa", en: "Map" },
  "landing.trust.4": { it: "Pipeline", en: "Pipeline" },
  "landing.features.eyebrow": { it: "Funzionalità", en: "Features" },
  "landing.features.title_a": { it: "Segnali che diventano deal,", en: "Signals that turn into deals," },
  "landing.features.title_b": { it: "senza switch di tool.", en: "without switching tools." },
  "landing.feat.warroom.eyebrow": { it: "War Room", en: "War Room" },
  "landing.feat.warroom.title": { it: "Una sala operativa globale", en: "A global operations room" },
  "landing.feat.warroom.desc": { it: "Vedi tutti i tuoi competitor, clienti, potenziali clienti e fornitori sulla mappa mondiale. Scegli il marker, apri la scheda, scarica documenti, aggiorna intelligence in tempo reale. Un unico cockpit per il team commerciale.", en: "See all your competitors, clients, prospects and suppliers on the world map. Pick a marker, open the card, download documents, update intelligence in real time. One cockpit for the whole sales team." },
  "landing.feat.warroom.b1": { it: "Markers competitor / cliente live", en: "Live competitor / client markers" },
  "landing.feat.warroom.b2": { it: "Schede editabili multi-utente", en: "Editable multi-user cards" },
  "landing.feat.warroom.b3": { it: "Brochure, case study e financial snapshot scaricabili", en: "Downloadable brochures, case studies and financial snapshots" },
  "landing.feat.sales.eyebrow": { it: "Sales Intelligence", en: "Sales Intelligence" },
  "landing.feat.sales.title": { it: "OSINT · SOCMINT · HUMINT in un click", en: "OSINT · SOCMINT · HUMINT in one click" },
  "landing.feat.sales.desc": { it: "Costruisci un dossier investigativo completo per ogni persona e azienda target. News, social, interazioni dirette strutturate in una timeline coerente e ricercabile.", en: "Build a complete investigative dossier for every target person and company. News, social, direct interactions structured in a coherent, searchable timeline." },
  "landing.feat.sales.b1": { it: "Fonti aperte ordinate cronologicamente", en: "Open sources sorted chronologically" },
  "landing.feat.sales.b2": { it: "Social signals (LinkedIn, X, Instagram)", en: "Social signals (LinkedIn, X, Instagram)" },
  "landing.feat.sales.b3": { it: "Timeline fiere, call, email con outcome", en: "Timeline of trade shows, calls, emails with outcomes" },
  "landing.feat.dash.eyebrow": { it: "Dashboard", en: "Dashboard" },
  "landing.feat.dash.title": { it: "Decisioni in tempo reale", en: "Real-time decisions" },
  "landing.feat.dash.desc": { it: "KPI numerici assoluti, mappa dei prossimi eventi globali, distribuzione ID Profiling e stato della pipeline HR tutto in un'unica schermata.", en: "Absolute numeric KPIs, global upcoming events map, ID Profiling distribution and HR pipeline status — all on a single screen." },
  "landing.feat.dash.b1": { it: "Aggiornamento live dai moduli", en: "Live updates from modules" },
  "landing.feat.dash.b2": { it: "Edit diretto dei valori in dashboard", en: "Direct in-dashboard value editing" },
  "landing.feat.dash.b3": { it: "Export PDF della presentazione piattaforma", en: "PDF export of the platform presentation" },
  "landing.modules.eyebrow": { it: "Moduli", en: "Modules" },
  "landing.modules.title_a": { it: "11 moduli.", en: "11 modules." },
  "landing.modules.title_b": { it: "1 cockpit.", en: "1 cockpit." },
  "landing.modules.sub": { it: "Ogni modulo condivide dati, ricerche e permessi. Zero silos, massima coerenza.", en: "Every module shares data, searches and permissions. Zero silos, maximum consistency." },
  "landing.mod.james.desc": { it: "Cockpit AI conversazionale che interroga la piattaforma, correla dati e produce analisi su richiesta.", en: "Conversational AI cockpit that queries the platform, correlates data and produces analysis on demand." },
  "landing.mod.supplier.desc": { it: "Monitor fornitori, dipendenze critiche, rating affidabilità e segnali di rischio sulla supply chain.", en: "Supplier monitor, critical dependencies, reliability rating and supply-chain risk signals." },
  "landing.mod.academy.desc": { it: "Materiali formativi, masterclass e workflow operativi per accelerare l'onboarding del team commerciale.", en: "Training materials, masterclasses and operational workflows to accelerate sales team onboarding." },
  "landing.mod.library.desc": { it: "Knowledge center, report di settore, template e repository documentale condiviso tra i team.", en: "Knowledge center, sector reports, templates and shared documental repository across teams." },
  "landing.mod.identity.desc": { it: "Profile ID, Business ID e liste di profilazione di persone e aziende con ricerca avanzata e tag personalizzati.", en: "Profile ID, Business ID and profiling lists of people and companies with advanced search and custom tags." },
  "landing.mod.sales.desc": { it: "Intelligence strutturata OSINT / SOCMINT / HUMINT: news, social, timeline interazioni per ogni target.", en: "Structured OSINT / SOCMINT / HUMINT intelligence: news, social, interaction timeline for every target." },
  "landing.mod.event.desc": { it: "Tradeshow tracker e Network Events: monitora fiere globali, competitor presenti e opportunità commerciali.", en: "Tradeshow tracker and Network Events: monitor global trade shows, competitors present and commercial opportunities." },
  "landing.mod.warroom.desc": { it: "Mappa mondiale live di competitor e clienti. Schede dettaglio con mercati, portfolio e documenti scaricabili.", en: "Live world map of competitors and clients. Detail cards with markets, portfolio and downloadable documents." },
  "landing.mod.hr.desc": { it: "Pipeline candidati con score algoritmico, check CV automatico, note HR e analisi anomalie.", en: "Candidate pipeline with algorithmic score, automatic CV check, HR notes and anomaly analysis." },
  "landing.mod.tech.desc": { it: "Brevetti competitor e stack tecnologico rilevato con score di anzianità e label Moderno / Obsoleto.", en: "Competitor patents and detected tech stack with age score and Modern / Obsolete label." },
  "landing.mod.ctx.desc": { it: "4 mappe globali: Dogane, Finanziaria, Commerciale, Gare pubbliche per presidiare il contesto normativo.", en: "4 global maps: Customs, Financial, Commercial, Public Tenders to monitor the regulatory context." },
  "landing.mod.try_title": { it: "Prova la piattaforma", en: "Try the platform" },
  "landing.mod.try_desc": { it: "Accedi con le credenziali demo e vedi tutto in azione.", en: "Log in with the demo credentials and see it all in action." },
  "landing.mod.try_cta": { it: "Vai al login", en: "Go to login" },
  "landing.security.eyebrow": { it: "Sicurezza", en: "Security" },
  "landing.security.title_a": { it: "I tuoi dati,", en: "Your data," },
  "landing.security.title_b": { it: "solo tuoi.", en: "yours only." },
  "landing.security.sub": { it: "Isolamento totale multitenant, autenticazione JWT con cookie httpOnly, esportazioni disabilitate per default a protezione del capitale informativo aziendale.", en: "Full multitenant isolation, JWT authentication with httpOnly cookies, exports disabled by default to protect your information capital." },
  "landing.security.b1": { it: "Autenticazione JWT access + refresh token (httpOnly, secure).", en: "JWT authentication with access + refresh token (httpOnly, secure)." },
  "landing.security.b2": { it: "Multitenancy: ogni client_id vede esclusivamente i propri dati.", en: "Multitenancy: each client_id only sees its own data." },
  "landing.security.b3": { it: "Export nativo disabilitato. Download selettivo solo su documenti pubblici.", en: "Native export disabled. Selective download only on public documents." },
  "landing.security.b4": { it: "Hosting su Kubernetes managed con supervisor e health check.", en: "Hosting on managed Kubernetes with supervisor and health checks." },
  "landing.security.isolated": { it: "Dati isolati per tenant", en: "Data isolated per tenant" },
  "landing.cta.title_a": { it: "Pronto a vedere", en: "Ready to see" },
  "landing.cta.title_b_highlight": { it: "i tuoi competitor", en: "your competitors" },
  "landing.cta.title_c": { it: "come non li hai mai visti?", en: "like you've never seen them before?" },
  "landing.cta.sub": { it: "Accedi subito alla tua piattaforma MOONSTONE. Demo pre-caricata con schede competitor, intelligence strutturata e mappa globale pronti all'uso.", en: "Access your MOONSTONE platform now. Pre-loaded demo with competitor cards, structured intelligence and global map ready to use." },
  "landing.cta.button": { it: "Entra ora", en: "Enter now" },
  "landing.footer.tag": { it: "Competitive & Sales Intelligence", en: "Competitive & Sales Intelligence" },
  "landing.footer.confidential": { it: "CONFIDENZIALE", en: "CONFIDENTIAL" },

  // ── Common page actions
  "action.refresh": { it: "Aggiorna", en: "Refresh" },
  "action.edit_data": { it: "Modifica Dati", en: "Edit Data" },
  "action.search": { it: "Cerca", en: "Search" },
  "action.save": { it: "Salva", en: "Save" },
  "action.cancel": { it: "Annulla", en: "Cancel" },
  "action.add": { it: "Aggiungi", en: "Add" },
  "action.download": { it: "Scarica", en: "Download" },
  "action.view": { it: "Visualizza", en: "View" },
  "action.open": { it: "Apri", en: "Open" },
  "action.filter": { it: "Filtra", en: "Filter" },
  "action.clear": { it: "Pulisci", en: "Clear" },
  "action.upload": { it: "Carica", en: "Upload" },

  // ── Dashboard
  "dash.title": { it: "Dashboard", en: "Dashboard" },
  "dash.overview": { it: "Overview", en: "Overview" },
  "dash.kpi.id_profile": { it: "Profili ID", en: "ID Profiles" },
  "dash.kpi.id_business": { it: "Aziende ID", en: "ID Businesses" },
  "dash.kpi.intel_items": { it: "Intelligence Items", en: "Intelligence Items" },
  "dash.kpi.tech_patent": { it: "Tech & Brevetti", en: "Tech & Patents" },
  "dash.profiling_title": { it: "Profiling", en: "Profiling" },
  "dash.profiling_persons": { it: "Persone", en: "Persons" },
  "dash.profiling_companies": { it: "Aziende", en: "Companies" },
  "dash.tradeshow_map": { it: "Mappa Fiere", en: "Tradeshow Map" },
  "dash.upcoming_events": { it: "Prossimi Eventi", en: "Upcoming Events" },
  "dash.recent_updates": { it: "Ultimi Aggiornamenti", en: "Latest Updates" },
  "dash.hr_score": { it: "HR Agency — Score Candidati", en: "HR Agency — Candidate Score" },
  "dash.cv_verified": { it: "CV Verificato", en: "Verified CV" },
  "dash.cv_minor": { it: "Anomalie Minori", en: "Minor Anomalies" },
  "dash.cv_not_recommended": { it: "Sconsigliato", en: "Not Recommended" },
  "dash.no_hr_data": { it: "Nessun dato HR", en: "No HR data" },
  "dash.no_events": { it: "Nessun evento in agenda", en: "No upcoming events" },
  "dash.no_contacts_updated": { it: "Nessun contatto aggiornato", en: "No updated contacts" },
  "dash.no_companies_updated": { it: "Nessuna azienda aggiornata", en: "No updated companies" },
  "dash.recent_people": { it: "Ultimi aggiornamenti - People", en: "Latest updates - People" },
  "dash.recent_company": { it: "Ultimi aggiornamenti - Company", en: "Latest updates - Company" },
  "dash.id_distribution": { it: "ID Profiling — Distribuzione", en: "ID Profiling — Distribution" },
  "dash.total_targets": { it: "target totali", en: "total targets" },
  "dash.hr_check_cv": { it: "HR Agency — Check CV", en: "HR Agency — CV Check" },
  "dash.hr_candidates_analyzed": { it: "candidati analizzati", en: "candidates analyzed" },
  "dash.download_brochure": { it: "Scarica Brochure", en: "Download Brochure" },
  "dash.edit_metrics_title": { it: "Modifica Metriche", en: "Edit Metrics" },

  // ── War Room
  "warroom.title": { it: "War Room", en: "War Room" },
  "warroom.subtitle": { it: "Mappa Globale Intelligence", en: "Global Intelligence Map" },
  "warroom.competitor": { it: "Competitor", en: "Competitor" },
  "warroom.prospect": { it: "Potenziale Cliente", en: "Prospect" },
  "warroom.client": { it: "Cliente", en: "Customer" },
  "warroom.potential_supplier": { it: "Potenziale Fornitore", en: "Potential Supplier" },
  "warroom.supplier": { it: "Fornitore", en: "Supplier" },
  "warroom.competitors": { it: "Competitor", en: "Competitors" },
  "warroom.prospects": { it: "Potenziali Clienti", en: "Prospects" },
  "warroom.clients": { it: "Clienti", en: "Customers" },
  "warroom.potential_suppliers": { it: "Potenziali Fornitori", en: "Potential Suppliers" },
  "warroom.suppliers": { it: "Fornitori", en: "Suppliers" },
  "warroom.all": { it: "Tutti", en: "All" },
  "warroom.add_marker": { it: "Aggiungi Marker", en: "Add Marker" },
  "warroom.empty": { it: "Nessun marker presente", en: "No markers yet" },
  "warroom.files": { it: "Documenti", en: "Documents" },
  "warroom.no_files": { it: "Nessun documento allegato", en: "No attached documents" },
  "warroom.sector": { it: "Settore", en: "Sector" },
  "warroom.notes": { it: "Note", en: "Notes" },
  "warroom.marker_name": { it: "Nome Marker", en: "Marker Name" },
  "warroom.city": { it: "Città", en: "City" },
  "warroom.country": { it: "Paese", en: "Country" },
  "warroom.type": { it: "Tipo", en: "Type" },
  "warroom.profile": { it: "Descrizione Strategica", en: "Strategic Notes" },
  "warroom.profile_title": { it: "Profilo Aziendale", en: "Company Profile" },
  "warroom.field_sector": { it: "Settore", en: "Sector" },
  "warroom.field_founded": { it: "Fondata", en: "Founded" },
  "warroom.field_employees": { it: "Dipendenti", en: "Employees" },
  "warroom.field_revenue": { it: "Fatturato", en: "Revenue" },
  "warroom.field_hq": { it: "Sede", en: "HQ" },
  "warroom.field_website": { it: "Sito Web", en: "Website" },
  "warroom.markets_present": { it: "Mercati Presenti", en: "Present Markets" },
  "warroom.known_clients": { it: "Clienti Noti", en: "Known Clients" },
  "warroom.no_markets": { it: "Nessun mercato registrato", en: "No markets recorded" },
  "warroom.no_clients": { it: "Nessun cliente registrato", en: "No clients recorded" },
  "warroom.no_description": { it: "Nessuna descrizione.", en: "No description." },
  "warroom.description_placeholder": { it: "Descrizione del competitor/cliente...", en: "Competitor/client description..." },
  "warroom.markets_placeholder": { it: "es. Italia, Germania, Francia (separati da virgola)", en: "e.g. Italy, Germany, France (comma separated)" },
  "warroom.clients_placeholder": { it: "es. Fiat, Pirelli, Enel (separati da virgola)", en: "e.g. Fiat, Pirelli, Enel (comma separated)" },
  "warroom.save_changes": { it: "Salva Modifiche", en: "Save Changes" },
  "warroom.documents": { it: "Documenti", en: "Documents" },
  "warroom.documents_info": { it: "Brochure, case study e report finanziari scaricabili.", en: "Downloadable brochures, case studies and financial reports." },
  "warroom.no_documents": { it: "Nessun documento disponibile.", en: "No documents available." },
  "action.edit": { it: "Modifica", en: "Edit" },

  // ── HR
  "hr.title": { it: "Monitor Candidati", en: "Candidate Monitor" },
  "hr.subtitle": { it: "HR Intelligence · Candidati pre-verificati", en: "HR Intelligence · Pre-verified candidates" },
  "hr.candidate": { it: "Candidato", en: "Candidate" },
  "hr.role": { it: "Ruolo", en: "Role" },
  "hr.current_company": { it: "Azienda Attuale", en: "Current Company" },
  "hr.score": { it: "Score", en: "Score" },
  "hr.check_cv": { it: "Verifica CV", en: "CV Check" },
  "hr.disputes": { it: "Vertenze", en: "Disputes" },
  "hr.no_disputes": { it: "Nessuna", en: "None" },
  "hr.recommended": { it: "Consigliato", en: "Recommended" },
  "hr.not_recommended": { it: "Sconsigliato", en: "Not recommended" },
  "hr.invented_info": { it: "Informazioni Inventate", en: "Fabricated Information" },
  "hr.cv_verified": { it: "CV Verificato", en: "Verified CV" },
  "hr.cv_minor": { it: "Anomalie Minori", en: "Minor Anomalies" },
  "hr.not_advised": { it: "Sconsigliati", en: "Not Recommended" },
  "hr.kpi_total": { it: "Totale", en: "Total" },
  "hr.kpi_verified": { it: "Verificati", en: "Verified" },
  "hr.kpi_anomalies": { it: "Anomalie Minori", en: "Minor Anomalies" },
  "hr.kpi_not_advised": { it: "Sconsigliati", en: "Not Recommended" },
  "hr.kpi_avg_score": { it: "Score Medio", en: "Avg Score" },
  "hr.sort_score_desc": { it: "Score decrescente", en: "Score descending" },
  "hr.sort_score_asc": { it: "Score crescente", en: "Score ascending" },
  "hr.header_subtitle": { it: "HR Agency — Background Check & Scoring", en: "HR Agency — Background Check & Scoring" },
  "hr.col_candidate": { it: "Candidato", en: "Candidate" },
  "hr.col_role": { it: "Ruolo", en: "Role" },
  "hr.col_current_company": { it: "Azienda Attuale", en: "Current Company" },
  "hr.col_score": { it: "Score", en: "Score" },
  "hr.col_check": { it: "Check CV", en: "CV Check" },
  "hr.col_anomalies": { it: "Anomalie", en: "Anomalies" },
  "hr.col_previous": { it: "Aziende Prev.", en: "Prev. Companies" },
  "hr.no_disputes_long": { it: "Nessuna vertenza nota", en: "No known disputes" },
  "hr.no_anomalies": { it: "Nessuna anomalia", en: "No anomalies" },
  "hr.disputes_history": { it: "Storico Vertenze", en: "Dispute History" },
  "hr.anomalies_detected": { it: "Anomalie Rilevate", en: "Detected Anomalies" },
  "hr.work_history": { it: "Storico Lavorativo", en: "Work History" },
  "hr.internal_notes": { it: "Note Interne (modificabili)", en: "Internal Notes (editable)" },
  "hr.notes_placeholder": { it: "Inserisci note interne sul candidato...", en: "Enter internal notes on the candidate..." },
  "hr.save_notes": { it: "Salva Note", en: "Save Notes" },

  // ── Tech & Patents
  "tech.title": { it: "Tecnologie", en: "Technologies" },
  "tech.subtitle": { it: "Software & Hardware Intelligence", en: "Software & Hardware Intelligence" },
  "tech.company": { it: "Azienda", en: "Company" },
  "tech.software": { it: "Tecnologie Software", en: "Software Technologies" },
  "tech.hardware": { it: "Macchinari & Hardware", en: "Machinery & Hardware" },
  "tech.tech_score": { it: "Score Tech", en: "Tech Score" },
  "tech.since": { it: "dal", en: "since" },
  "tech.patents.title": { it: "Brevetti", en: "Patents" },
  "tech.patents.subtitle": { it: "Patent Intelligence · Portafoglio brevetti", en: "Patent Intelligence · Patent portfolio" },
  "tech.patents.filed": { it: "Depositato", en: "Filed" },
  "tech.patents.status": { it: "Stato", en: "Status" },

  // ── Contextual Intelligence
  "ctx.customs.title": { it: "Contesto Dogane", en: "Customs Context" },
  "ctx.customs.subtitle": { it: "Normativa doganale e regolamenti import/export", en: "Customs regulations and import/export rules" },
  "ctx.finance.title": { it: "Contesto Finanziario", en: "Financial Context" },
  "ctx.finance.subtitle": { it: "Incentivi, bandi e opportunità di finanziamento", en: "Incentives, grants and funding opportunities" },
  "ctx.commerce.title": { it: "Contesto Commerciale", en: "Commercial Context" },
  "ctx.commerce.subtitle": { it: "Opportunità commerciali e scenari di mercato", en: "Commercial opportunities and market scenarios" },
  "ctx.tenders.title": { it: "Gare & Appalti", en: "Tenders & Bids" },
  "ctx.tenders.subtitle": { it: "Bandi e gare aperte a livello nazionale ed europeo", en: "Open tenders at national and European level" },
  "ctx.name": { it: "Nome", en: "Name" },
  "ctx.deadline": { it: "Scadenza", en: "Deadline" },
  "ctx.amount": { it: "Importo", en: "Amount" },
  "ctx.country": { it: "Paese", en: "Country" },
  "ctx.sector": { it: "Settore", en: "Sector" },
  "ctx.customs.complexity": { it: "Complessità Doganale", en: "Customs Complexity" },
  "ctx.customs.subtitle2": { it: "Barriere doganali e complessità import/export per paese", en: "Customs barriers and import/export complexity by country" },
  "ctx.finance.risk": { it: "Rischio Finanziario", en: "Financial Risk" },
  "ctx.finance.subtitle2": { it: "Restrizioni finanziarie e rischio normativo per paese", en: "Financial restrictions and regulatory risk by country" },
  "ctx.commerce.ease": { it: "Facilità Commerciale", en: "Commercial Ease" },
  "ctx.commerce.subtitle2": { it: "Facilità commerciale e vincoli di vendita per paese", en: "Commercial ease and sales constraints by country" },
  "ctx.tenders.opportunity": { it: "Opportunità", en: "Opportunity" },
  "ctx.tenders.subtitle2": { it: "Opportunità di gare pubbliche e appalti attivi per paese", en: "Public tender opportunities and active bids by country" },
  "ctx.legend.low_complexity": { it: "Bassa complessità (≤40)", en: "Low complexity (≤40)" },
  "ctx.legend.medium_complexity": { it: "Media complessità (40–70)", en: "Medium complexity (40–70)" },
  "ctx.legend.high_complexity": { it: "Alta complessità (≥70)", en: "High complexity (≥70)" },
  "ctx.legend.low_risk": { it: "Basso rischio (≤40)", en: "Low risk (≤40)" },
  "ctx.legend.medium_risk": { it: "Rischio medio (40–70)", en: "Medium risk (40–70)" },
  "ctx.legend.high_risk": { it: "Alto rischio (≥70)", en: "High risk (≥70)" },
  "ctx.legend.high_ease": { it: "Alta facilità (≤40 vincoli)", en: "High ease (≤40 constraints)" },
  "ctx.legend.medium_ease": { it: "Facilità media (40–70)", en: "Medium ease (40–70)" },
  "ctx.legend.low_ease": { it: "Bassa facilità (≥70 vincoli)", en: "Low ease (≥70 constraints)" },
  "ctx.legend.open_tender": { it: "Gara aperta / appalto attivo", en: "Open tender / active bid" },
  "ctx.legend.expiring": { it: "In scadenza (< 30 gg)", en: "Expiring (< 30d)" },
  "ctx.legend.closed_tender": { it: "Scaduta / chiusa", en: "Expired / closed" },
  "ctx.sectors_all": { it: "Tutti", en: "All" },
  "ctx.loading": { it: "Caricamento dati normativi...", en: "Loading regulatory data..." },
  "ctx.by_sector": { it: "Filtra per settore", en: "Filter by sector" },

  // ── Academy
  "academy.training.title": { it: "Corsi di Formazione", en: "Training Courses" },
  "academy.training.subtitle": { it: "Video corsi e materiali formativi", en: "Video courses and training materials" },
  "academy.docs.title": { it: "Documenti Corsi", en: "Course Documents" },
  "academy.docs.subtitle": { it: "Slide, PDF e guide operative", en: "Slides, PDFs and operational guides" },
  "academy.level": { it: "Livello", en: "Level" },
  "academy.instructor": { it: "Docente", en: "Instructor" },
  "academy.duration": { it: "Durata", en: "Duration" },
  "academy.watch": { it: "Guarda", en: "Watch" },
  "academy.read": { it: "Leggi", en: "Read" },

  // ── Library
  "lib.knowledge.title": { it: "Knowledge Center", en: "Knowledge Center" },
  "lib.knowledge.subtitle": { it: "Base di conoscenza e metodologie", en: "Knowledge base and methodologies" },
  "lib.reports.title": { it: "Report & Documenti", en: "Reports & Documents" },
  "lib.reports.subtitle": { it: "Ricerche di mercato e report settoriali", en: "Market research and industry reports" },
  "lib.repository.title": { it: "Repository", en: "Repository" },
  "lib.repository.subtitle": { it: "Archivio documenti e risorse condivise", en: "Document archive and shared resources" },
  "lib.persons": { it: "Persone", en: "Persons" },
  "lib.companies": { it: "Aziende", en: "Companies" },
  "lib.targets_list": { it: "target nella lista", en: "targets in list" },

  // ── Sales / Identity Card
  "sales.people.title": { it: "Persone", en: "People" },
  "sales.people.subtitle": { it: "Identity Card · Profili contatti", en: "Identity Card · Contact profiles" },
  "sales.company.title": { it: "Aziende", en: "Companies" },
  "sales.company.subtitle": { it: "Identity Card · Profili aziendali", en: "Identity Card · Company profiles" },
  "sales.list.title": { it: "Lista", en: "List" },
  "sales.list.subtitle": { it: "Identity Card · Vista lista completa", en: "Identity Card · Complete list view" },
  "sales.search_placeholder_person": { it: "Cerca per nome...", en: "Search by name..." },
  "sales.search_placeholder_company": { it: "Cerca per nome azienda...", en: "Search by company name..." },
  "sales.no_results": { it: "Nessun risultato trovato", en: "No results found" },
  "sales.loading_contacts": { it: "Caricamento contatti...", en: "Loading contacts..." },
  "sales.loading_companies": { it: "Caricamento aziende...", en: "Loading companies..." },
  "sales.companies_count": { it: "aziende", en: "companies" },
  "sales.contacts_count": { it: "contatti", en: "contacts" },
  "sales.financial_analysis": { it: "Analisi Finanziaria", en: "Financial Analysis" },
  "sales.key_contacts": { it: "Contatti Chiave", en: "Key Contacts" },
  "sales.technologies_lbl": { it: "Tecnologie", en: "Technologies" },

  // ── Network / Event Intelligence
  "net.tradeshow.title": { it: "B2B Fairs Monitor", en: "B2B Fairs Monitor" },
  "net.tradeshow.subtitle": { it: "Event Intelligence · Fiere B2B e manifestazioni di settore", en: "Event Intelligence · B2B fairs & industry exhibitions" },
  "net.tradeshow.fair": { it: "Fiera B2B", en: "B2B Fair" },
  "net.tradeshow.about": { it: "Informazioni sulla Fiera", en: "About the Tradeshow" },
  "net.tradeshow.exhibitors": { it: "espositori", en: "exhibitors" },
  "net.tradeshow.no_exhibitors": { it: "Nessun espositore registrato per questa fiera.", en: "No exhibitors registered for this tradeshow." },
  "net.tradeshow.click_hint": { it: "Clicca una riga per i dettagli e la lista espositori", en: "Click a row for details and exhibitors list" },
  "sales.download_balance": { it: "Scarica Bilancio (PDF)", en: "Download Balance Sheet (PDF)" },
  "net.events.title": { it: "B2B Events Monitor", en: "B2B Events Monitor" },
  "net.events.subtitle": { it: "Event Intelligence · Eventi aziendali privati e pubblici ospitati da altre aziende", en: "Event Intelligence · Private and public corporate events hosted by other companies" },
  "net.date": { it: "Data", en: "Date" },
  "net.city": { it: "Città", en: "City" },
  "net.country": { it: "Paese", en: "Country" },
  "net.sector": { it: "Settore", en: "Sector" },

  // ── Dashboard: Panoramica Censimento
  "dash.overview.title": { it: "Panoramica censimento", en: "Census Overview" },
  "dash.overview.subtitle": { it: "Volumi complessivi per modulo", en: "Total volumes per module" },
  "dash.overview.people_list": { it: "People List", en: "People List" },
  "dash.overview.business_list": { it: "Business List", en: "Business List" },
  "dash.overview.business_asset": { it: "Business Asset", en: "Business Asset" },
  "dash.overview.events_fairs": { it: "Event and Fairs", en: "Events and Fairs" },

  // ── Dashboard: Centro di Controllo Supply Chain
  "dash.supply.title": { it: "Centro di Controllo Supply Chain", en: "Supply Chain Control Center" },
  "dash.supply.subtitle": { it: "Segnali fornitori · Ultimi 3 mesi · Radar Procurement", en: "Supplier signals · Last 3 months · Procurement Radar" },
  "dash.supply.declining_short": { it: "Peggior.", en: "Declining" },
  "dash.supply.improving_short": { it: "Miglior.", en: "Improving" },
  "dash.supply.open_warroom": { it: "Apri War Room", en: "Open War Room" },
  "dash.supply.early_warning": { it: "Early Warning", en: "Early Warning" },
  "dash.supply.positive_signal": { it: "Positive Signal", en: "Positive Signal" },
  "dash.supply.score_minus_10": { it: "Score −10 pt", en: "Score −10 pt" },
  "dash.supply.score_plus_10": { it: "Score +10 pt", en: "Score +10 pt" },
  "dash.supply.no_critical": { it: "Nessun segnale critico", en: "No critical signals" },
  "dash.supply.stable_period": { it: "Fornitori stabili nel periodo", en: "Suppliers stable in the period" },
  "dash.supply.no_improvement": { it: "Nessun miglioramento", en: "No improvements" },
  "dash.supply.radar_monitoring": { it: "Radar in monitoraggio", en: "Radar in monitoring" },
  "dash.supply.open_warroom_card": { it: "Apri scheda War Room", en: "Open War Room card" },
  "dash.supply.no_notes": { it: "Nessuna nota disponibile.", en: "No notes available." },
  "dash.reason.delivery_delay": { it: "Ritardi consegna", en: "Delivery delays" },
  "dash.reason.price_increase": { it: "Prezzi in aumento", en: "Price increases" },
  "dash.reason.quality": { it: "Qualità/Reclami", en: "Quality/Complaints" },
  "dash.reason.lead_time": { it: "Lead time", en: "Lead time" },
  "dash.reason.sla": { it: "SLA sotto target", en: "SLA below target" },
  "dash.reason.logistics": { it: "Congestione logistica", en: "Logistics congestion" },
  "dash.reason.renegotiation": { it: "Rinegoziazione", en: "Renegotiation" },

  // ── Dashboard: Company Health Check + Traffic Light
  "dash.health.title": { it: "Company Health Check", en: "Company Health Check" },
  "dash.health.aggregate_sub": { it: "Vista aggregata su {n} aziende di Business List", en: "Aggregate view · {n} companies in Business List" },
  "dash.health.single_sub": { it: "Vista singola azienda", en: "Single-company view" },
  "dash.health.aggregate": { it: "Vista aggregata", en: "Aggregate view" },
  "dash.health.tracked": { it: "{n} aziende monitorate", en: "{n} companies tracked" },
  "dash.health.search_placeholder": { it: "Cerca un'azienda in Business List…", en: "Search a company in Business List…" },
  "dash.health.score": { it: "Score", en: "Score" },
  "dash.health.legend_low": { it: "0–40 Migliorabile", en: "0–40 Low" },
  "dash.health.legend_mid": { it: "40–70 Mediocre", en: "40–70 Fair" },
  "dash.health.legend_high": { it: "70–100 Ottimo", en: "70–100 Optimal" },
  "dash.health.aggregate_label": { it: "Aggregato", en: "Aggregate" },
  "dash.tl.needs_work": { it: "Migliorabile", en: "Needs work" },
  "dash.tl.fair": { it: "Mediocre", en: "Fair" },
  "dash.tl.optimal": { it: "Ottimo", en: "Optimal" },
  "dash.tl.vs_last": { it: "vs mese scorso", en: "vs last month" },
  "dash.health.employees_short": { it: "dip.", en: "emp." },
  "dash.health.delta_3m": { it: "Δ 3m", en: "Δ 3m" },

  // ── Dashboard: Insight del Giorno (già definiti sopra)

  // ── Dashboard: Header/Actions
  "dash.title": { it: "Dashboard", en: "Dashboard" },
  "dash.subtitle": { it: "{client} — Overview", en: "{client} — Overview" },
  "dash.refresh": { it: "Aggiorna", en: "Refresh" },
  "dash.edit_data": { it: "Modifica Dati", en: "Edit Data" },
  "dash.recent_updates_people": { it: "Ultimi aggiornamenti - People", en: "Recent Updates - People" },
  "dash.recent_updates_company": { it: "Ultimi aggiornamenti - Company", en: "Recent Updates - Company" },
  "dash.n_recent": { it: "{n} recenti", en: "{n} recent" },

  // ── Regulatory Affairs (ex Compliance)
  "reg.title": { it: "Regulatory Affairs", en: "Regulatory Affairs" },
  "reg.subtitle": { it: "Compliance globale · Dogane, Finanziaria, Commerciale, Gare", en: "Global compliance · Customs, Financial, Trade, Tenders" },
  "reg.cat.dogane": { it: "Dogane", en: "Customs" },
  "reg.cat.finanziaria": { it: "Finanziaria", en: "Financial" },
  "reg.cat.commerciale": { it: "Commerciale", en: "Trade" },
  "reg.cat.gare": { it: "Gare & Appalti", en: "Tenders & Contracts" },
  "reg.filter.category": { it: "Categoria", en: "Category" },
  "reg.filter.risk": { it: "Rischio", en: "Risk" },
  "reg.filter.marking": { it: "Marcatura", en: "Marking" },
  "reg.filter.sector": { it: "Settore Gara", en: "Tender Sector" },
  "reg.filter.amount": { it: "Importo", en: "Amount" },
  "reg.filter.regulation": { it: "Normativa Finanziaria", en: "Financial Regulation" },
  "reg.risk.high": { it: "Alto", en: "High" },
  "reg.risk.mid": { it: "Medio", en: "Medium" },
  "reg.risk.low": { it: "Basso", en: "Low" },
  "reg.filters_title": { it: "Filtri", en: "Filters" },
  "reg.reset": { it: "Reset filtri", en: "Reset filters" },
  "reg.list_title": { it: "Elenco Normative", en: "Regulations List" },
  "reg.map_title": { it: "Mappa Compliance", en: "Compliance Map" },
  "reg.no_results": { it: "Nessun risultato per i filtri applicati", en: "No results for applied filters" },
  "reg.popup.open_detail": { it: "Apri scheda dettaglio →", en: "Open detail card →" },
  "reg.detail.score": { it: "Score", en: "Score" },
  "reg.detail.sector": { it: "Settore", en: "Sector" },
  "reg.detail.amount": { it: "Importo", en: "Amount" },
  "reg.detail.deadline": { it: "Scadenza", en: "Deadline" },
  "reg.filter.active": { it: "attivo", en: "active" },
  "reg.filter.active_plural": { it: "attivi", en: "active" },

  // ── Contract Twin ─────────────────────────────────────────────────────────
  "ct.subtitle": { it: "Estrazione clausole PDF · Monitor tasso BCE · Alert", en: "PDF clause extraction · ECB rate monitor · Alerts" },
  "ct.tab.dashboard": { it: "Dashboard", en: "Dashboard" },
  "ct.tab.contracts": { it: "Contratti", en: "Contracts" },
  "ct.tab.analytics": { it: "Analytics", en: "Analytics" },
  "ct.tab.alerts": { it: "Alert", en: "Alerts" },
  "ct.stat.contracts": { it: "Contratti", en: "Contracts" },
  "ct.stat.clauses": { it: "Clausole estratte", en: "Extracted clauses" },
  "ct.stat.review": { it: "Da revisionare", en: "Need review" },
  "ct.stat.alerts": { it: "Alert attivi", en: "Active alerts" },
  "ct.stat.ecb": { it: "Tasso BCE", en: "ECB rate" },
  "ct.by_type": { it: "Clausole per tipo", en: "Clauses by type" },
  "ct.clause.renewal": { it: "Rinnovo", en: "Renewal" },
  "ct.clause.price_revision": { it: "Revisione prezzo", en: "Price revision" },
  "ct.clause.penalty": { it: "Penale", en: "Penalty" },
  "ct.clause.termination": { it: "Recesso", en: "Termination" },
  "ct.clause.parity_clause": { it: "Parity clause", en: "Parity clause" },
  "ct.tab.whatif": { it: "What-If", en: "What-If" },
  "ct.tab.counterparties": { it: "Controparti", en: "Counterparties" },
  "ct.tab.predictions": { it: "Previsioni", en: "Predictions" },
  "ct.whatif.presets": { it: "Scenari predefiniti", en: "Predefined scenarios" },
  "ct.whatif.compose": { it: "Componi scenario custom", en: "Compose custom scenario" },
  "ct.whatif.current": { it: "Attuale", en: "Current" },
  "ct.whatif.run": { it: "Esegui simulazione", en: "Run simulation" },
  "ct.whatif.running": { it: "Simulazione…", en: "Simulating…" },
  "ct.whatif.total_exposure": { it: "Esposizione totale stimata", en: "Total estimated exposure" },
  "ct.whatif.impacted": { it: "contratti impattati", en: "contracts impacted" },
  "ct.whatif.direct": { it: "diretti", en: "direct" },
  "ct.whatif.indirect": { it: "indiretti", en: "indirect" },
  "ct.whatif.no_value": { it: "esclusi dal totale (valore non disponibile)", en: "excluded from total (value not available)" },
  "ct.whatif.contracts_list": { it: "Contratti impattati", en: "Impacted contracts" },
  "ct.whatif.direct_badge": { it: "Diretto", en: "Direct" },
  "ct.whatif.indirect_badge": { it: "Indiretto", en: "Indirect" },
  "ct.whatif.no_value_short": { it: "n/d", en: "n/a" },
  "ct.whatif.empty": { it: "Nessun contratto impattato in questo scenario", en: "No contracts impacted in this scenario" },
  "ct.counterparties.empty": { it: "Nessuna controparte censita", en: "No counterparty registered" },
  "ct.counterparties.concentration": { it: "Rischio concentrazione", en: "Concentration risk" },
  "ct.counterparties.exposed_to": { it: "Esposta a", en: "Exposed to" },
  "ct.counterparties.total_value": { it: "Valore totale", en: "Total value" },
  "ct.predictions.eta": { it: "ETA attivazione", en: "Activation ETA" },
  "ct.predictions.current": { it: "Attuale", en: "Current" },
  "ct.predictions.days": { it: "Giorni stimati", en: "Estimated days" },
  "ct.predictions.insufficient": { it: "Dati storici insufficienti per", en: "Insufficient history for" },
  "ct.predictions.empty": { it: "Nessuna previsione: tutte le clausole sono già attivate oppure i trend non convergono al superamento nei prossimi 10 anni.", en: "No predictions: all clauses already triggered or trends don't reach threshold within 10 years." },
  "ct.contract.value": { it: "Valore contratto (EUR)", en: "Contract value (EUR)" },
  "ct.contract.counterparty": { it: "Controparte", en: "Counterparty" },
  "ct.contract.linked_to": { it: "Contratto collegato", en: "Linked contract" },
  "ct.contract.select_linked": { it: "Seleziona contratto collegato…", en: "Select linked contract…" },
  "ct.contract.no_link": { it: "Nessun collegamento", en: "No link" },
  "ct.negotiation.title": { it: "Impatto di una rinegoziazione", en: "Renegotiation impact" },
  "ct.negotiation.desc": { it: "Seleziona una clausola: mostreremo gli altri contratti collegati via grafo che potrebbero richiedere attenzione.", en: "Select a clause: we'll show other graph-linked contracts that may need attention." },
  "ct.negotiation.select": { it: "Seleziona clausola…", en: "Select clause…" },
  "ct.negotiation.no_impact": { it: "Nessun altro contratto collegato a questa clausola.", en: "No other contracts linked to this clause." },
  "ct.negotiation.impacted": { it: "contratti hanno clausole collegate che potrebbero richiedere attenzione", en: "contracts have linked clauses that may need attention" },
  "ct.negotiation.hops": { it: "salti", en: "hops" },
  "ct.alerts.exposure": { it: "Esposizione", en: "Exposure" },
  "ct.alerts.direct_indirect": { it: "diretti / indiretti", en: "direct / indirect" },
  "ct.alerts.contracts": { it: "contratti", en: "contracts" },
  "ct.alerts.status": { it: "Stato", en: "Status" },
  "ct.nlquery.impacted": { it: "contratti impattati", en: "contracts impacted" },
  "ct.upload.drop": { it: "Trascina qui i PDF o clicca per selezionare", en: "Drop PDFs here or click to select" },
  "ct.upload.processing": { it: "Caricamento ed estrazione clausole via LLM…", en: "Uploading & extracting clauses via LLM…" },
  "ct.upload.hint": { it: "Max 20MB per file · estrazione clausole via Gemini 2.5 Flash", en: "Max 20MB per file · Gemini 2.5 Flash extraction" },
  "ct.upload.failed": { it: "Upload fallito", en: "Upload failed" },
  "ct.list.title": { it: "Contratti caricati", en: "Uploaded contracts" },
  "ct.list.empty": { it: "Nessun contratto caricato", en: "No contracts uploaded yet" },
  "ct.list.filename": { it: "Nome file", en: "Filename" },
  "ct.list.date": { it: "Data", en: "Date" },
  "ct.list.status": { it: "Stato", en: "Status" },
  "ct.list.clauses": { it: "Clausole", en: "Clauses" },
  "ct.list.refresh": { it: "aggiorna", en: "refresh" },
  "ct.confirm_delete": { it: "Eliminare il contratto e le clausole associate?", en: "Delete contract and its clauses?" },
  "ct.status.processed": { it: "Elaborato", en: "Processed" },
  "ct.status.error": { it: "Errore", en: "Error" },
  "ct.status.processing": { it: "Elaborazione", en: "Processing" },
  "ct.status.pending": { it: "In coda", en: "Pending" },
  "ct.badge.review": { it: "Da revisionare", en: "Needs review" },
  "ct.badge.verified": { it: "Verificata", en: "Verified" },
  "ct.field.confidence": { it: "Confidenza", en: "Confidence" },
  "ct.field.deadline": { it: "Scadenza", en: "Deadline" },
  "ct.field.condition": { it: "Condizione", en: "Condition" },
  "ct.field.consequence": { it: "Conseguenza", en: "Consequence" },
  "ct.field.threshold": { it: "Soglia", en: "Threshold" },
  "ct.field.type": { it: "Tipo", en: "Type" },
  "ct.field.source_text": { it: "Testo sorgente", en: "Source text" },
  "ct.field.deadline_placeholder": { it: "Scadenza (AAAA-MM-GG)", en: "Deadline (YYYY-MM-DD)" },
  "ct.edit.tooltip": { it: "Modifica", en: "Edit" },
  "ct.edit.save": { it: "Salva e verifica", en: "Save & verify" },
  "ct.edit.cancel": { it: "Annulla", en: "Cancel" },
  "ct.edit.save_failed": { it: "Salvataggio fallito", en: "Save failed" },
  "ct.detail.back": { it: "Indietro", en: "Back" },
  "ct.detail.clauses": { it: "clausole", en: "clauses" },
  "ct.detail.to_review": { it: "da revisionare", en: "to review" },
  "ct.detail.no_clauses": { it: "Nessuna clausola estratta.", en: "No clauses extracted." },
  "ct.pdf.loading": { it: "Caricamento PDF…", en: "Loading PDF…" },
  "ct.pdf.zoom_in": { it: "Ingrandisci", en: "Zoom in" },
  "ct.pdf.zoom_out": { it: "Riduci", en: "Zoom out" },
  "ct.rate.admin_title": { it: "Tasso BCE — controllo admin", en: "ECB rate — admin control" },
  "ct.rate.save": { it: "Aggiorna e valuta alert", en: "Update & evaluate alerts" },
  "ct.rate.saving": { it: "Salvo…", en: "Saving…" },
  "ct.rate.sync": { it: "Sincronizza da BCE", en: "Sync from ECB" },
  "ct.rate.syncing": { it: "Sincronizzo…", en: "Fetching…" },
  "ct.rate.sync_failed": { it: "Sincronizzazione fallita", en: "Sync failed" },
  "ct.rate.update_failed": { it: "Aggiornamento fallito", en: "Update failed" },
  "ct.rate.hint": { it: "Impostazione manuale o sync one-click dal portale dati BCE (tasso MRR fisso). Gli alert sono idempotenti.", en: "Manual set or one-click fetch from ECB Data Portal (MRR fixed rate). Alerts are idempotent." },
  "ct.alerts.title": { it: "Alert", en: "Alerts" },
  "ct.alerts.empty": { it: "Nessun alert. Modifica il tasso BCE per attivarne di nuovi.", en: "No alerts. Change ECB rate to trigger new ones." },
  "ct.alerts.trigger": { it: "Trigger", en: "Trigger" },
  "ct.alerts.open": { it: "apri", en: "open" },
  "ct.alerts.resolve": { it: "risolvi", en: "resolve" },
  "ct.alerts.reopen": { it: "riapri", en: "reopen" },
  "ct.analytics.by_type": { it: "Esposizione per tipo clausola", en: "Exposure by clause type" },
  "ct.analytics.confidence": { it: "Distribuzione confidenza", en: "Confidence distribution" },
  "ct.analytics.confidence_high": { it: "Alta ≥85%", en: "High ≥85%" },
  "ct.analytics.confidence_medium": { it: "Media 70-85%", en: "Medium 70-85%" },
  "ct.analytics.confidence_low": { it: "Bassa <70%", en: "Low <70%" },
  "ct.analytics.timeline": { it: "Scadenze nel tempo", en: "Deadlines timeline" },
  "ct.analytics.timeline_empty": { it: "Nessuna clausola con scadenza", en: "No dated clauses" },
  "ct.analytics.review": { it: "Stato revisione", en: "Review status" },
  "ct.analytics.ecb_title": { it: "Clausole legate al tasso BCE", en: "ECB-linked clauses" },
  "ct.analytics.ecb_exposed": { it: "Clausole legate a BCE", en: "ECB-linked clauses" },
  "ct.pdf.error": { it: "PDF non disponibile", en: "PDF unavailable" },
  "ct.loading": { it: "Caricamento…", en: "Loading…" },
  "menu.contract_twin": { it: "Contract Twin", en: "Contract Twin" },
  "menu.due_diligence": { it: "Due Diligence", en: "Due Diligence" },
  "menu.entity_loss": { it: "Simulazione Perdita Entità", en: "Entity Loss Simulation" },
  "menu.cyber_exposure": { it: "Cyber Exposure", en: "Cyber Exposure" },
  "menu.live_world": { it: "Live World", en: "Live World" },
  "menu.intelligence": { it: "Intelligence", en: "Intelligence" },
  "menu.b2b_fairs": { it: "B2B Fairs", en: "B2B Fairs" },
  "menu.b2b_events": { it: "B2B Events", en: "B2B Events" },
  "menu.business_asset": { it: "Business Asset", en: "Business Asset" },
  "menu.regulatory_affairs": { it: "Regulatory Affairs", en: "Regulatory Affairs" },
  "menu.legal": { it: "Legal", en: "Legal" },
  "menu.cyber_ops": { it: "Cyber Ops", en: "Cyber Ops" },
  "ct.tab.recommendations": { it: "Raccomandazioni", en: "Recommendations" },
  "ct.nlquery.placeholder": { it: "Chiedi: es. 'Cosa succede se Beta S.r.l. fallisce?'", en: "Ask: e.g. 'What if Beta S.r.l. defaults?'" },
  "ct.nlquery.button": { it: "Chiedi", en: "Ask" },
  "ct.nlquery.title": { it: "Query in linguaggio naturale", en: "Natural language query" },
  "ct.nlquery.unknown": { it: "Non sono riuscito a interpretare la domanda, prova a riformularla o usa i filtri.", en: "I couldn't interpret the question, try rephrasing or use the filters." },
  "ct.nlquery.interpreted_as": { it: "Interpretata come", en: "Interpreted as" },
  "ct.cp_registry.title": { it: "Registro controparti", en: "Counterparty registry" },
  "ct.cp_registry.add": { it: "Aggiungi controparte", en: "Add counterparty" },
  "ct.cp_registry.name": { it: "Nome", en: "Name" },
  "ct.cp_registry.risk": { it: "Stato di rischio", en: "Risk status" },
  "ct.cp_risk.stable": { it: "Stabile", en: "Stable" },
  "ct.cp_risk.watch": { it: "Osservazione", en: "Watch" },
  "ct.cp_risk.distressed": { it: "Distressed", en: "Distressed" },
  "ct.cp_risk.default": { it: "Default", en: "Default" },
  "ct.cp_risk.unmonitored": { it: "Non monitorata", en: "Unmonitored" },
  "ct.reco.title": { it: "Raccomandazioni di mitigazione", en: "Mitigation recommendations" },
  "ct.reco.generate": { it: "Genera raccomandazioni", en: "Generate recommendations" },
  "ct.reco.empty": { it: "Nessuna raccomandazione attiva. Clicca 'Genera' per analizzare i pattern di concentrazione.", en: "No active recommendations. Click 'Generate' to analyze concentration patterns." },
  "ct.reco.consider": { it: "Considerata", en: "Considered" },
  "ct.reco.dismiss": { it: "Scarta", en: "Dismiss" },
  "ct.reco.reopen": { it: "Riapri", en: "Reopen" },
  "ct.reco.disclaimer": { it: "Suggerimento algoritmico. Non è parere legale o finanziario.", en: "Algorithmic suggestion. Not legal or financial advice." },
  "ct.report.generate": { it: "Genera Report PDF", en: "Generate PDF report" },
  "ct.report.generating": { it: "Generazione in corso…", en: "Generating…" },
  "ct.dd.title": { it: "Due Diligence", en: "Due Diligence" },
  "ct.dd.new_project": { it: "Nuovo progetto", en: "New project" },
  "ct.dd.projects": { it: "Progetti attivi", en: "Active projects" },
  "ct.dd.empty": { it: "Nessun progetto Due Diligence. Creane uno per analizzare un portafoglio esterno isolato.", en: "No Due Diligence project. Create one to analyze an isolated external portfolio." },
  "ct.dd.upload_bulk": { it: "Carica contratti (drag & drop multiplo)", en: "Upload contracts (multi drag & drop)" },
  "ct.dd.summary": { it: "Sintesi progetto", en: "Project summary" },
  "ct.dd.contracts_count": { it: "Contratti", en: "Contracts" },
  "ct.dd.low_conf": { it: "Clausole a bassa confidence", en: "Low confidence clauses" },
  "ct.dd.top_cp": { it: "Top controparti per concentrazione", en: "Top counterparties" },
  "ct.dd.download_report": { it: "Scarica report PDF", en: "Download PDF report" },
  "ct.predictions.reneg_window": { it: "Finestra rinegoziazione", en: "Renegotiation window" },
  "ct.predictions.why": { it: "Perché questa finestra?", en: "Why this window?" },
  "ct.alerts.type_counterparty": { it: "Rischio controparte", en: "Counterparty risk" },
  "ct.alerts.type_market": { it: "Variabile di mercato", en: "Market variable" },
  "ct.type.leasing": { it: "Leasing", en: "Leasing" },
  "ct.type.indexed_supply": { it: "Fornitura indicizzata", en: "Indexed supply" },
  "ct.type.saas_license": { it: "SaaS / Licenze software", en: "SaaS / Software license" },
  "ct.type.nda": { it: "NDA", en: "NDA" },
  "ct.type.other": { it: "Altro", en: "Other" },
  "ct.upload.type_label": { it: "Tipo di contratto (obbligatorio)", en: "Contract type (required)" },
  "ct.upload.type_hint": { it: "Il tipo determina il prompt LLM specializzato per l'estrazione", en: "The type determines the specialized LLM extraction prompt" },
  "ct.contract.type": { it: "Tipo contratto", en: "Contract type" },
  "ct.contract.reprocess": { it: "Rilancia estrazione", en: "Reprocess extraction" },
  "ct.contract.reprocessing": { it: "Estrazione in corso…", en: "Reprocessing…" },
  "ct.list.filter_type": { it: "Filtra per tipo", en: "Filter by type" },
  "ct.list.all_types": { it: "Tutti i tipi", en: "All types" },
  "ct.admin.types_title": { it: "Tipi di contratto attivi", en: "Active contract types" },
  "ct.admin.types_hint": { it: "Disattiva un tipo per impedirne l'upload. I contratti esistenti restano consultabili.", en: "Disable a type to block new uploads. Existing contracts remain accessible." },
  "ct.admin.enabled": { it: "Attivo", en: "Enabled" },
  "ct.admin.disabled": { it: "Disattivato", en: "Disabled" },
  "ct.admin.locked_other": { it: "Fallback obbligatorio", en: "Mandatory fallback" },
  "ct.nda.hidden_notice": { it: "Le sezioni economiche, il grafo delle dipendenze e le variabili esterne sono nascoste per questo tipo di contratto (NDA).", en: "Economic sections, dependency graph and external variables are hidden for this contract type (NDA)." },
  "ct.field.trigger": { it: "Trigger", en: "Trigger" },
  "ct.field.trigger_variable": { it: "Variabile trigger", en: "Trigger variable" },
  "ct.field.llm_hint": { it: "Suggerimento LLM", en: "LLM hint" },
  "ct.timeline.owner": { it: "Owner", en: "Owner" },
  "ct.timeline.status": { it: "Stato azione", en: "Action status" },
  "ct.timeline.notes": { it: "Note", en: "Notes" },
  "ct.timeline.save": { it: "Salva", en: "Save" },
  "ct.timeline.cancel": { it: "Annulla", en: "Cancel" },
  "ct.timeline.edit": { it: "Modifica azione", en: "Edit action" },
  "ct.timeline.no_owner": { it: "Nessun owner", en: "No owner" },
  "ct.timeline.saved_by": { it: "Aggiornato da", en: "Updated by" },
  "ct.timeline.status.todo": { it: "Da fare", en: "To do" },
  "ct.timeline.status.in_progress": { it: "In corso", en: "In progress" },
  "ct.timeline.status.done": { it: "Completato", en: "Done" },
  "ct.timeline.status.deferred": { it: "Rimandato", en: "Deferred" },

  // ─── Entity Loss Simulation ────────────────────────────────────────
  "el.title": { it: "Simulazione Perdita Entità", en: "Entity Loss Simulation" },
  "el.subtitle": { it: "Cosa succede se perdiamo questo cliente o fornitore? Impatto aggregato su Contratti, Sales, Supply Chain e R&D.", en: "What happens if we lose this customer or supplier? Aggregated impact across Contracts, Sales, Supply Chain and R&D." },
  "el.search_placeholder": { it: "Cerca un'entità (cliente, fornitore, partner)…", en: "Search an entity (customer, supplier, partner)…" },
  "el.simulate": { it: "Simula perdita", en: "Simulate loss" },
  "el.compare_mode": { it: "Modalità confronto", en: "Compare mode" },
  "el.add_to_compare": { it: "Aggiungi al confronto", en: "Add to compare" },
  "el.remove_from_compare": { it: "Rimuovi", en: "Remove" },
  "el.run_compare": { it: "Confronta (2-3 entità)", en: "Compare (2-3 entities)" },
  "el.no_results": { it: "Nessuna entità trovata", en: "No entities found" },
  "el.na": { it: "Dato non disponibile", en: "Data not available" },
  "el.risk_level": { it: "Livello di rischio complessivo", en: "Overall risk level" },
  "el.risk.high": { it: "Alto", en: "High" },
  "el.risk.medium": { it: "Medio", en: "Medium" },
  "el.risk.low": { it: "Basso", en: "Low" },
  "el.kyc_status": { it: "Status KYC", en: "KYC status" },
  "el.total_at_risk": { it: "Valore totale a rischio", en: "Total value at risk" },
  "el.breakdown": { it: "Scomposizione", en: "Breakdown" },
  "el.breakdown.contracts": { it: "Contratti", en: "Contracts" },
  "el.breakdown.sales_open": { it: "Pipeline Sales aperta", en: "Open sales pipeline" },
  "el.breakdown.sales_historic": { it: "Fatturato storico 12m", en: "Historic revenue 12m" },
  "el.sec.contracts": { it: "Contratti impattati", en: "Impacted contracts" },
  "el.sec.sales": { it: "Pipeline Sales a rischio", en: "Sales pipeline at risk" },
  "el.sec.supply": { it: "Esposizione Supply Chain", en: "Supply Chain exposure" },
  "el.sec.rd": { it: "Dipendenze R&D", en: "R&D dependencies" },
  "el.link.direct": { it: "Diretto", en: "Direct" },
  "el.link.indirect": { it: "Indiretto", en: "Indirect" },
  "el.link.hops": { it: "hop", en: "hop" },
  "el.deal.advanced": { it: "Fase avanzata", en: "Advanced stage" },
  "el.supply.not_a_supplier": { it: "L'entità non è mappata come fornitore nella Supply Chain.", en: "Entity is not mapped as a supplier in Supply Chain." },
  "el.supply.alt_available": { it: "Alternativa disponibile", en: "Alternative available" },
  "el.supply.no_alt": { it: "Nessuna alternativa nota", en: "No known alternative" },
  "el.supply.lead_time": { it: "Lead time sostituzione", en: "Substitution lead time" },
  "el.rd.unique": { it: "Dipendenza unica", en: "Unique dependency" },
  "el.rd.no_data": { it: "Nessuna dipendenza R&D nota per questa entità.", en: "No known R&D dependency for this entity." },
  "el.narrative_title": { it: "Sintesi del rischio", en: "Risk summary" },
  "el.narrative_disclaimer": { it: "Sintesi generata da AI sulla base dei dati sottostanti. I dati numerici mostrati sopra sono la fonte autoritativa.", en: "AI-generated summary based on the data below. The numbers above remain the authoritative source." },
  "el.loading": { it: "Simulazione in corso…", en: "Running simulation…" },
  "el.days": { it: "gg", en: "days" },
  "el.no_selection": { it: "Cerca un'entità per iniziare, oppure attiva la modalità confronto per analizzare 2-3 entità in parallelo.", en: "Search an entity to start, or enable compare mode to analyse 2-3 entities in parallel." },
  "el.watchlist.add": { it: "Aggiungi alla watchlist", en: "Add to watchlist" },
  "el.watchlist.remove": { it: "Rimuovi watchlist", en: "Remove watchlist" },
  "el.watchlist.threshold_ph": { it: "Soglia €", en: "Threshold €" },
  "el.watchlist.title": { it: "Watchlist entità critiche", en: "Critical entities watchlist" },
  "el.watchlist.limit": { it: "Massimo 5 entità in watchlist", en: "Maximum 5 entities in watchlist" },
  "el.watchlist.no_alerts": { it: "Nessun alert attivo. Le esposizioni sono sotto la soglia impostata.", en: "No active alert. Exposures are below the set threshold." },
  "el.watchlist.threshold": { it: "Soglia", en: "Threshold" },
  "el.watchlist.exposure": { it: "Esposizione attuale", en: "Current exposure" },
  "el.watchlist.alert": { it: "Alert soglia superata", en: "Threshold breached" },
  "el.watchlist.empty": { it: "Nessuna entità nella watchlist. Aggiungine fino a 5 dalla vista di dettaglio di un'entità.", en: "No entity in the watchlist. Add up to 5 from the entity detail view." },

  // ── Variables (external sources) ─────────────────────────────────────
  "ct.var.ecb_rate": { it: "Tasso BCE", en: "ECB rate" },
  "ct.var.eur_usd": { it: "Cambio EUR/USD", en: "EUR/USD rate" },
  "ct.var.oil_brent": { it: "Petrolio Brent", en: "Brent oil" },
  "ct.var.fixed_date": { it: "Data fissa", en: "Fixed date" },
  "ct.var.other": { it: "Altro", en: "Other" },

  // ── Alert types ──────────────────────────────────────────────────────
  "ct.alert_type.counterparty_risk": { it: "Rischio controparte", en: "Counterparty risk" },
  "ct.alert_type.market_variable": { it: "Variabile di mercato", en: "Market variable" },

  // ── Alert status ─────────────────────────────────────────────────────
  "ct.alert_status.active": { it: "Attivo", en: "Active" },
  "ct.alert_status.resolved": { it: "Risolto", en: "Resolved" },

  // ── Recommendation status ────────────────────────────────────────────
  "ct.reco_status.active": { it: "Attiva", en: "Active" },
  "ct.reco_status.considered": { it: "Considerata", en: "Considered" },
  "ct.reco_status.dismissed": { it: "Scartata", en: "Dismissed" },
  "ct.reco.archive": { it: "Archivio", en: "Archive" },

  // ── Contract status ──────────────────────────────────────────────────
  "ct.cstatus.processed": { it: "Elaborato", en: "Processed" },
  "ct.cstatus.processing": { it: "In elaborazione", en: "Processing" },
  "ct.cstatus.pending": { it: "In coda", en: "Pending" },
  "ct.cstatus.error": { it: "Errore", en: "Error" },

  // ── Review status ────────────────────────────────────────────────────
  "ct.review.verified": { it: "Verificata", en: "Verified" },
  "ct.review.needs_review": { it: "Da revisionare", en: "Needs review" },

  // ── Intent (NL Query) ────────────────────────────────────────────────
  "ct.intent.counterparty_risk": { it: "Rischio controparte", en: "Counterparty risk" },
  "ct.intent.variable_impact": { it: "Impatto variabile", en: "Variable impact" },
  "ct.intent.whatif": { it: "Simulazione what-if", en: "What-if simulation" },
  "ct.intent.unknown": { it: "Non riconosciuta", en: "Unknown" },
};

export function t(key, lang = "it") {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] || entry.it || key;
}


export default dict;
